<template>
<div class="chapter">
<div class="inner_page">
<div id="epub4231-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-1" id="toc_marker-4" xml:lang="en-GB"><img alt="Titles.jpg" class="image" height="317" src="images/Titles_fmt.jpeg" width="317"/></p>
<p class="TitlePublisher para-style-override-2"><img alt="L-1.tif" class="image" height="23" src="images/L-1_fmt.png" width="26"/></p>
<p class="TitlePublisher">Atlantic Monthly Press</p>
<p class="TitleCity">New York</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epub4231-3.vue?66283dd4